"use strict";

var isUndefined = require('lodash/isUndefined');

function match(object, settings) {
  var key = settings.key,
      value = settings.value;

  if (key == null) {
    throw new Error('No key specified for match');
  }

  if (value == null) {
    throw new Error('No value specified against which to match');
  } // get the desired value from the object.


  var val = object[key];

  if (isUndefined(val)) {
    console.error(JSON.stringify(object, null, 2));
    throw new Error("".concat(key, " returned undefined"));
  }

  if (val == null) {
    // need to return false here because
    // later we coerce the value into a string
    // so the value is "null", which we're not
    // interested in matching.
    return false;
  }

  var comparator; // we can specify a regular expression in the options with regexp:/<grp1>/<grp2>

  if (String(value).match(/regexp:\/(.*)\/([a-z]*)/)) {
    var matcher = String(value).match(/regexp:\/(.*)\/([a-z]*)/);
    var grp1 = matcher[1];
    var grp2 = matcher[2];
    comparator = new RegExp(grp1, grp2);
  } else {
    comparator = value;
  }

  var matches = String(val).match(comparator);
  return !!matches;
}

module.exports = match;